const windowIfAvailable = (): Window | HTMLElement | any => {
  if(typeof window === `undefined`) return {}
  else return window
}

export { windowIfAvailable }